// React components
import * as React from "react";
import _ from "lodash";
import SplitPane from 'react-split-pane';

// Material UI components
import FlatButton from 'material-ui/FlatButton';
import { Toolbar, ToolbarGroup, ToolbarTitle } from 'material-ui/Toolbar';

// Internal functions
import "../JSEditor.less"
import { IComponentSizeProp } from '@Primitive/Interfaces';
import { MonacoEditor } from '@Primitive/Monaco';
import { Markdown } from './MarkdownLazy';
import { IsNullOrWhiteSpace } from "@Utils/Micro";
// ================================================================================================
export interface MarkdownEditorProps extends React.Props<MarkdownEditor>, IComponentSizeProp {
    Title: string;
    Text: string;
    readOnly?: boolean;
    onCloseRequest: () => void;
    onSave: (newData: any) => void;
    hideDiscardButton?: boolean;
    saveLabel?: string;
}
// ------------------------------------------------------------------------------------------------
export interface MarkdownEditorState {
    Text: string;
    SplitSize: number;
}
// ------------------------------------------------------------------------------------------------
export class MarkdownEditor extends React.Component<MarkdownEditorProps, MarkdownEditorState> {
    constructor(props: MarkdownEditorProps) {
        super(props);

        this.state = {
            Text: _.cloneDeep(props.Text),
            SplitSize: 0.5
        }

    }
    // ---------------------------------------------------------------------------------------------------
    render() {
        const color = "rgb(91, 97, 99)";
        let toolbarHeight = 35;
        let height = this.props.height - toolbarHeight;
        let editorWidth = Math.ceil(this.state.SplitSize * this.props.width);

        return <div style={{ overflow: "hidden", backgroundColor: "rgb(39, 40, 34)" }}>
            <Toolbar style={{ height: toolbarHeight, boxShadow: "rgba(0, 0, 0, 0.16) 0px 3px 10px, rgba(0, 0, 0, 0.23) 0px 3px 10px", position: "relative", color: "white", backgroundColor: color, zIndex: 20 }} >
                <ToolbarGroup>
                    <ToolbarTitle style={{ color: "white", fontSize: 16 }} text={this.props.Title} />
                </ToolbarGroup>
                <ToolbarGroup style={{ color: "white" }} lastChild={true}>
                    {this.props.hideDiscardButton == true
                        ? null
                        : <FlatButton
                            label='Discard'
                            style={{ margin: 0 }}
                            secondary={true}
                            onClick={() => {
                                this.setState({ Text: _.cloneDeep(this.props.Text) });
                            }}
                        />}
                    <FlatButton
                        label='Cancel'
                        style={{ margin: 0 }}
                        secondary={true}
                        onClick={() => {
                            this.props.onCloseRequest();
                        }}
                    />
                    <FlatButton
                        label={!IsNullOrWhiteSpace(this.props.saveLabel) ? this.props.saveLabel : 'Save'}
                        style={{ margin: 0 }}
                        primary={true}
                        onClick={() => {
                            this.props.onSave(this.state.Text);
                            this.props.onCloseRequest();
                        }}
                    />
                </ToolbarGroup>
            </Toolbar>
            <SplitPane split="vertical"
                style={{ position: "relative" }}
                minSize={250}
                defaultSize={editorWidth}
                onDragFinished={(newSize) => this.setState({ SplitSize: newSize / this.props.width })}
            >
                <div>
                    <div
                        style={{
                            padding: '8px 0px',
                            backgroundColor: '#ddd',
                            textAlign: 'center',
                            boxShadow: "rgba(0, 0, 0, 0.16) 0px 3px 10px, rgba(0, 0, 0, 0.23) 0px 3px 10px",
                            zIndex: 19
                        }}>
                        {'Markdown'}
                    </div>

                    <MonacoEditor
                        value={this.state.Text}
                        onChange={(value) => this.setState({ Text: value })}
                        height={height - 38}
                        language="markdown"
                        theme="vs-dark"
                        options={{ selectOnLineNumbers: true, readOnly: this.props.readOnly }}
                    />
                </div>
                <div>
                    <div
                        style={{
                            padding: '8px 0px',
                            backgroundColor: '#ddd',
                            textAlign: 'center',
                            boxShadow: "rgba(0, 0, 0, 0.16) 0px 3px 10px, rgba(0, 0, 0, 0.23) 0px 3px 10px",
                            zIndex: 19
                        }}>
                        {'Preview'}
                    </div>
                    <div
                        style={{
                            padding: '0 4px',
                            overflow: 'auto',
                            height: height - 38,
                            backgroundColor: "white"
                        }}>
                        <Markdown
                            width={this.props.width - editorWidth}
                            source={this.state.Text} />
                    </div>
                </div>

            </SplitPane>
        </div>
    }

}
